import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { API_URL } from "@equine-ui-nx/injection-tokens";

@Injectable({
  providedIn: 'root'
})
export class PaymentExposedService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL);

  getCartsTable(payerReference: string, pageSize: number, pageIndex: number) {
    const CARTS_TABLE = `payments/getCartTableFromPayerReference`;

    const payload = {
      payerReference,
      pageSize,
      pageIndex
    };


    return this.http.post(`${this.apiUrl}/${CARTS_TABLE}`, payload);
  }

  getCartDetailsByCartId(cartId: string) {
    const CART_DETAILS = `payments/getCartDetailsById`;

    const payload = {
      cartId
    };
    return this.http.post(`${this.apiUrl}/${CART_DETAILS}`, payload);
  }

}